module.exports = __webpack_public_path__ + "img/logo_shulan.19331711.png";